import { createContext, useContext } from 'react';
import { ApiScaleInfo, ApiWeighing } from '@Model';

export interface IScalesContext {
    availableScales: Array<ApiScaleInfo>;
    canUseAutomaticWeighing: boolean;

    selectedScale: ApiScaleInfo | undefined;
    selectScale: (scale: ApiScaleInfo | undefined) => void;

    getWeight: (scale: ApiScaleInfo) => Promise<ApiWeighing | undefined>;
}

export const ScalesContext = createContext<IScalesContext>({
    availableScales: [],
    canUseAutomaticWeighing: false,
    selectedScale: undefined,
    selectScale: () => {},
    getWeight: () => Promise.resolve(undefined),
});

export function useScales(): IScalesContext {
    const scalesContext = useContext(ScalesContext);
    return scalesContext;
}
